import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'
import size from '../../../../utills/size'

export const styleContent = {
    '#home-promo-banners': {
        ' .wds-demo-home-section': {
            '.wdsh-shopby': {
                h2: {
                    color: 'black',
                    textAlign: 'center',
                    height: pxToRem(30),
                    fontSize: pxToRem(22),
                    fontFamily: fonts.primary,
                    fontWeight: 600,
                    letterSpacing: pxToRem(3),
                    textTransform: 'uppercase'
                },
                [`@media (max-width: ${size.md})`]: {
                    h2: {
                        fontSize: pxToRem(18)
                    }
                },
                '.fade-in': {
                    opacity: '0',
                    transform: `translateY(${pxToRem(50)})`,
                    transition: 'opacity 0.8s ease, transform 0.8s ease'
                },
                '.fade-in.in-view': {
                    opacity: '1',
                    transform: 'translateY(0)'
                },
                a: {
                    display: 'block',
                    overflow: 'hidden'
                },
                img: {
                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out'
                },
                'a:hover img': {
                    transform: 'scale(1.05)',
                    boxShadow: `${pxToRem(0)} ${pxToRem(8)} ${pxToRem(18)} rgba(0, 0, 0, 0.2)`
                },
                'a p': {
                    fontSize: pxToRem(12),
                    letterSpacing: pxToRem(1),
                    fontFamily: fonts.primary,
                    fontWeight: 500,
                    lineHeight: pxToRem(22),

                    [`@media (min-width: ${size.md})`]: {
                        letterSpacing: pxToRem(1.8)
                    },

                    [`@media (min-width: ${size.lg})`]: {
                        fontSize: pxToRem(14),
                        letterSpacing: pxToRem(2.1)
                    }
                },
                'a:hover p': {
                    color: 'cav_red'
                }
            },
            [`@media (min-width: ${size.lg_1}) and (max-width: ${size.xxxl_1})`]: {
                maxWidth: pxToRem(1280),
                width: `calc(100% - ${pxToRem(192)})`,
                margin: '0 auto'
            },
            '.fade-in': {
                opacity: '0',
                transform: `translateY(${pxToRem(50)})`,
                transition: 'opacity 0.8s ease, transform 0.8s ease'
            },
            '.fade-in.in-view': {
                opacity: '1',
                transform: 'translateY(0)'
            },
            '.featured-block': {
                position: 'relative',
                display: 'block',
                [`@media (max-width: ${size.md})`]: {
                    padding: `${pxToRem(30)} ${pxToRem(11)}`,
                    width: pxToRem(320),
                    height: pxToRem(8)
                },
                '.overlay': {
                    position: 'absolute',
                    bottom: pxToRem(0.5),
                    width: '100%',
                    height: pxToRem(200),
                    background: ' rgba(0, 0, 0, 0.7)',
                    transition: 'background 0.3s ease-in-out'
                },
                /* Mobile view adjustments */
                [`@media (max-width: ${size.md})`]: {
                    '.overlay': {
                        display: 'flex',
                        width: pxToRem(311),
                        height: pxToRem(228),
                        padding: `${pxToRem(25)} ${pxToRem(58)}`,
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: pxToRem(10),
                        flexShrink: '0',
                        background: ' rgba(0, 0, 0, 0.7)'
                    }
                },
                ':hover .overlay': {
                    background: 'rgba(0, 0, 0, 0.6)'
                },
                '.content': {
                    color: 'white',
                    transition: 'transform 0.3s ease-in-out',
                    textAlign: 'center'
                },
                '.content h3': {
                    fontSize: pxToRem(18),
                    fontFamily: fonts.primary,
                    fontWeight: 600,
                    letterSpacing: pxToRem(3),

                    [`@media (min-width: ${size.md})`]: {
                        fontSize: pxToRem(22)
                    }
                },
                '.content p': {
                    textAlign: 'center',
                    fontSize: pxToRem(14),
                    fontFamily: fonts.primary,
                    letterSpacing: pxToRem(1),
                    fontWeight: 400,

                    [`@media (min-width: ${size.md})`]: {
                        fontSize: pxToRem(16),
                        letterSpacing: pxToRem(1.28)
                    }
                },
                /* Mobile view adjustments */
                [`@media (max-width: ${size.md})`]: {
                    '.content p': {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flexShrink: '0',
                        fontSize: pxToRem(4)
                    }
                },
                '.btn': {
                    transition: 'all 0.3s ease',
                    fontFamily: fonts.primary,
                    fontWeight: 700,
                    fontSize: pxToRem(12),
                    fontStyle: 'normal',
                    letterSpacing: pxToRem(1.44),
                    display: 'inline-block',
                    textDecoration: 'none',
                    minWidth: pxToRem(260),
                    textAlign: 'center',
                    padding: `${pxToRem(10)} ${pxToRem(20)}`,
                    background: 'white',
                    lineHeight: pxToRem(15),
                    color: 'cav_red',

                    [`@media (min-width: ${size.md})`]: {
                        fontSize: pxToRem(14),
                        letterSpacing: pxToRem(1.68),
                        minWidth: pxToRem(295),
                        lineHeight: pxToRem(16),
                        padding: `${pxToRem(12)} ${pxToRem(20)}`
                    }
                },
                '.btn:hover': {
                    background: 'cav_red',
                    color: 'white',
                    transform: 'scale(1.05)'
                }
            },
            [`@media (min-width: ${size.lg_1}) and (max-width: ${size.xxxl_1})`]: {
                maxWidth: pxToRem(1280),
                width: `calc(100% - ${pxToRem(192)})`,
                margin: '0 auto'
            }
        }
    }
}
